export default __webpack_public_path__ + "static/media/pattern-002-3.55204a14.jpg";